import { RJSFValidationError } from '@rjsf/utils';

export function transformErrors(errors: RJSFValidationError[]): RJSFValidationError[] {
  return errors.map((error) => {
    if (error.name === 'enum') {
      error.message = 'Please verify the provided input';
    } else if (error.name === 'required') {
      error.message = 'Please fill in this required field';
    } else if (error.name === 'type' && error.params?.type === 'string') {
      error.message = 'Please fill in this required field';
    }
    return error;
  });
}
